import { Controller, type FieldValues } from 'react-hook-form';

import { Field, FieldError, FieldLabel } from '@/components/ui/field';
import { Switch } from '@/components/ui/switch';

import { cn } from '@/lib/utils';
import { type CommonFormFieldProps, lgSpan, mdSpan, smSpan } from './form-input';

type FormSwitchProps<T extends FieldValues> = CommonFormFieldProps<T> & {
  description?: string;
  horizontal?: boolean;
};

export function FormSwitch<T extends FieldValues>({
  name,
  control,
  label,
  description,

  sm = 12,
  md = 4,
  lg = 4,

  required,
  horizontal,
  className,
}: FormSwitchProps<T>) {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState }) => (
        <Field
          className={cn(smSpan[sm], mdSpan[md], lgSpan[lg], className)}
          data-invalid={fieldState.invalid}
        >
          {!horizontal && (
            <FieldLabel htmlFor={name}>
              {label} {required && <strong className="text-red-500">*</strong>}
            </FieldLabel>
          )}

          <div className="flex items-center gap-4 h-9">
            <Switch
              id={name}
              checked={!!field.value}
              onCheckedChange={field.onChange}
              disabled={field.disabled}
            />
            {horizontal && (
              <FieldLabel htmlFor={name}>
                {label} {required && <strong className="text-red-500">*</strong>}
              </FieldLabel>
            )}
          </div>

          {description && <p className="text-muted-foreground text-sm">{description}</p>}

          {fieldState.error && <FieldError errors={[fieldState.error]} />}
        </Field>
      )}
    />
  );
}
